import React, { SyntheticEvent } from 'react';

import { Box, ButtonBase, Tooltip, TooltipProps } from '@methanesat/ui-components';

export type MapToggleButtonProps = {
    onClick: (event: SyntheticEvent) => void;
    imageSrc: string;
    TooltipProps?: Partial<TooltipProps>;
};

const MapToggleButton = (props: MapToggleButtonProps) => {
    const MapButton = (
        <ButtonBase
            id="base-map-button"
            data-testid="map-button"
            onClick={props.onClick}
            sx={[
                (theme) => ({
                    '&:hover > img': {
                        border: `2px solid ${theme.palette.action.hover}`,
                        borderRadius: theme.shape.borderRadius
                    }
                })
            ]}
        >
            <Box
                component="img"
                sx={(theme) => ({
                    width: '85px',
                    height: 'auto',
                    aspectRatio: '1',
                    borderRadius: theme.shape.borderRadius,
                    border: `5px solid ${theme.palette.lightGray.main}`
                })}
                src={props.imageSrc}
            />
        </ButtonBase>
    );

    return props.TooltipProps?.title ? (
        <Tooltip
            title={props.TooltipProps?.title || 'Default Map'}
            sx={{ alignSelf: 'center', marginLeft: 1 }}
            {...props.TooltipProps}
        >
            {MapButton}
        </Tooltip>
    ) : (
        MapButton
    );
};

export default MapToggleButton;
